import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../../../assets/images/course-img.jpg";
import { Link, useNavigate } from "react-router-dom";
import StudentsTable from "./studentsTable/studentsTable";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { getCourseByIdForCourses } from "../../../redux/features/courseSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Image } from "react-bootstrap";
import CourseDetailStudentTable from "../../../components/CourseDetailStudentTable/CourseDetailStudentTable";
import CourseDetailAssignment from "../../../components/CourseDetailAssignment/CourseDetailAssignment";
import { courseUnPublishAPI } from "../../../redux/features/courseSlice";
import AdminNotification from "../../../components/Notification/AdminNotification";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-hot-toast";
import DottedLoading from "../../../components/DottedLoading/DottedLoading";
import Reviews from "../../../components/Reviews/Reviews";
import TruncateText from "../../../components/truncateText/TruncateText";
import { deleteReviewAPI } from "../../../redux/features/adminSlice";
import CourseDetailChapterList from "../../../components/CourseDetailChapterList/CourseDetailChapterList";

const AdminCourseDetails = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [imagesSliderList, setImagesSliderList] = useState([]);
  const [getCourseDetail, setGetCourseDetail] = useState({});
  const [showUnpublishModal, setShowUnpublishModal] = useState(false);
  const [unpublishReason, setUnpublishReason] = useState("");
  const [unpublishReasonError, setUnpublishReasonError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const auth = useSelector((state) => state.auth);
  const [unpublishLoader, setUnpublishLoader] = useState();
  const [getCourseReview, setGetCourseReview] = useState({});
  const [getCourseDocument, setGetCourseDocument] = useState([]);
  const isDeacrive =
    auth?.role === "Admin" && getCourseDetail?.status === "pending_unpublished";

  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  const navOneSlider = {
    dots: true,
    infinite: false,
    arrows: false,
    asNavFor: nav2,
    ref: (slider) => (sliderRef1 = slider),
    beforeChange: (oldIndex, newIndex) => setActiveSlide(newIndex),
  };

  const navTwoSlider = {
    infinite: false,
    arrows: false,
    asNavFor: nav1,
    ref: (slider) => (sliderRef2 = slider),
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
  };

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);

    const getCoursesFetchCall = async () => {
      setIsLoading(true);
      try {
        const res = await dispatch(
          getCourseByIdForCourses({
            token: auth.token,
            courseId: searchParams.get("id"),
          })
        ).unwrap();
        console.log("data", res)
        if (res.success) {
          setGetCourseDetail(res.data);
          setGetCourseDocument(res.data);
          // Handle image_urls properly
          let images = [];
          if (res.data.image_urls) {
            try {
              images = JSON.parse(res.data.image_urls);
              // Ensure images is an array
              if (!Array.isArray(images)) {
                images = [images];
              }
            } catch (error) {
              console.error("Error parsing image_urls:", error);
              images = [img1]; // Fallback to default image
            }
          } else {
            images = [img1]; // Fallback to default image
          }
          setImagesSliderList(images);
          setGetCourseReview(res?.data?.reviews);
        }
      } catch (error) {
        console.error("Error fetching course:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getCoursesFetchCall();
  }, [dispatch, auth.token, searchParams]);

  const handleFullscreen = () => {
    const allImages = document.querySelectorAll("#mainImage");
    const currentImage = allImages[activeSlide];

    if (currentImage) {
      if (currentImage.requestFullscreen) {
        currentImage.requestFullscreen();
      } else if (currentImage.webkitRequestFullscreen) {
        currentImage.webkitRequestFullscreen();
      } else if (currentImage.msRequestFullscreen) {
        currentImage.msRequestFullscreen();
      }
    }
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  const handleUnpublishClick = () => {
    setShowUnpublishModal(true);
    setUnpublishReason("");
    setUnpublishReasonError("");
  };

  const handleUnpublishSubmit = async () => {
    setUnpublishLoader(true);
    if (!unpublishReason.trim()) {
      setUnpublishReasonError("Please provide a reason for unpublishing.");
      return;
    }
    setUnpublishReasonError("");
    try {
      const res = await dispatch(
        courseUnPublishAPI({
          token: auth.token,
          courseId: searchParams.get("id"),
          reason: unpublishReason.trim(),
        })
      ).unwrap();
      if (res.success) {
        toast.success(res.message, {
          position: "top-center",
        });
        setShowUnpublishModal(false);
        goBack();
      }
    } catch (error) {
      toast.error("Failed to unpublish course.", { position: "top-center" });
      setUnpublishLoader(false);
    } finally {
      setUnpublishLoader(false);
    }
  };

  const refreshGetCoursesFetchCall = async () => {
    try {
      const res = await dispatch(
        getCourseByIdForCourses({
          token: auth.token,
          courseId: searchParams.get("id"),
        })
      ).unwrap();
      if (res.success) {
        setGetCourseReview(res?.data?.reviews);
      }
    } catch (error) {
      console.error("Error fetching course:", error);
    }
  };

  const handleDeleteReview = async (reviewId) => {
    try {
      const res = await dispatch(
        deleteReviewAPI({ reviewId, token: auth.token })
      ).unwrap();
      console.log("kkk", res);
      toast.success("Review deleted successfully");

      refreshGetCoursesFetchCall();

      return true;
    } catch (err) {
      const errorMessage =
        err?.message || err?.error || "Failed to delete review";

      toast.error(errorMessage);
      return false;
    }
  };

  return (
    <>
      {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Course Details:
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>
      <div className="course-detail-content">
        <div className="row mb-20 mb-sm-30 mb-md-40">
          <div className="col-12 col-xl-5 mb-10 slider-align">
            <div className="mainImageContainer mb-15 mb-sm-27">
              <div className="slider-for-course-img">
                <Slider {...navOneSlider}>
                  {imagesSliderList.map((image, index) => (
                    <div key={index}>
                      <Image
                        id="mainImage"
                        src={
                          image.startsWith("/")
                            ? `${process.env.REACT_APP_GALLERY_URL}${image}`
                            : image
                        }
                        alt={`Course image ${index + 1}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = img1; // Fallback to default image
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
              <button className="fullscreen-btn" onClick={handleFullscreen}>
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.2053 1.549C18.2053 1.25009 18.0866 0.963425 17.8752 0.752066C17.6639 0.540707 17.3772 0.421967 17.0783 0.421967H11.4431C11.1442 0.421967 10.8576 0.540707 10.6462 0.752066C10.4349 0.963425 10.3161 1.25009 10.3161 1.549C10.3161 1.8479 10.4349 2.13457 10.6462 2.34593C10.8576 2.55729 11.1442 2.67603 11.4431 2.67603H14.3396L10.643 6.38395C10.5373 6.48873 10.4535 6.61338 10.3963 6.75072C10.339 6.88805 10.3096 7.03536 10.3096 7.18414C10.3096 7.33293 10.339 7.48024 10.3963 7.61757C10.4535 7.75491 10.5373 7.87956 10.643 7.98434C10.7477 8.08997 10.8724 8.17381 11.0097 8.23103C11.1471 8.28825 11.2944 8.31771 11.4431 8.31771C11.5919 8.31771 11.7392 8.28825 11.8766 8.23103C12.0139 8.17381 12.1386 8.08997 12.2433 7.98434L15.9513 4.27641V7.18414C15.9513 7.48305 16.07 7.76972 16.2814 7.98107C16.4927 8.19243 16.7794 8.31117 17.0783 8.31117C17.3772 8.31117 17.6639 8.19243 17.8752 7.98107C18.0866 7.76972 18.2053 7.48305 18.2053 7.18414V1.549ZM7.73522 10.8921C7.63045 10.7864 7.5058 10.7026 7.36846 10.6454C7.23112 10.5882 7.08381 10.5587 6.93503 10.5587C6.78625 10.5587 6.63894 10.5882 6.5016 10.6454C6.36426 10.7026 6.23961 10.7864 6.13484 10.8921L2.42691 14.5887V11.6923C2.42691 11.3934 2.30817 11.1067 2.09681 10.8953C1.88545 10.684 1.59879 10.5652 1.29988 10.5652C1.00097 10.5652 0.71431 10.684 0.502951 10.8953C0.291592 11.1067 0.172852 11.3934 0.172852 11.6923V17.3274C0.172852 17.6263 0.291592 17.913 0.502951 18.1243C0.71431 18.3357 1.00097 18.4544 1.29988 18.4544H6.93503C7.23394 18.4544 7.5206 18.3357 7.73196 18.1243C7.94332 17.913 8.06206 17.6263 8.06206 17.3274C8.06206 17.0285 7.94332 16.7418 7.73196 16.5305C7.5206 16.3191 7.23394 16.2004 6.93503 16.2004H4.02729L7.73522 12.4925C7.84086 12.3877 7.9247 12.263 7.98192 12.1257C8.03914 11.9884 8.06859 11.841 8.06859 11.6923C8.06859 11.5435 8.03914 11.3962 7.98192 11.2588C7.9247 11.1215 7.84086 10.9968 7.73522 10.8921Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>

            <div className="slick-slider-thumbs">
              <Slider {...navTwoSlider}>
                {imagesSliderList.map((image, index) => (
                  <div key={index}>
                    <Image
                      src={
                        image.startsWith("/")
                          ? `${process.env.REACT_APP_GALLERY_URL}${image}`
                          : image
                      }
                      alt={`Thumbnail ${index + 1}`}
                      className="thumb"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = img1; // Fallback to default image
                      }}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div className="col-12 col-xl-7 mb-10 content-align flex-grow-1">
            <div className="d-flex align-items-center justify-content-between mb-28">
              <div>
                <span className="ah-text-lg fw-bold text-green mb-12 text-uppercase d-block">
                  {getCourseDetail?.Category?.name}
                </span>
                <h2 className="ad-heading-01 fw-bold mb-0">
                  {getCourseDetail?.title}
                </h2>
              </div>
            </div>
            <TruncateText
              className="text-gray-01 ah-text-base mb-26"
              text={getCourseDetail?.description}
              limit={1000}
            />
            <div className="d-flex flex-wrap gap-3 mb-15">
              {getCourseDetail?.status === "published" && (
                <div>
                  <button
                    type="button"
                    data-type="no-before"
                    onClick={handleUnpublishClick}
                    disabled={false}
                    className="btn btn-primary ah-text-md fw-semibold no-shadow py-18"
                  >
                    Unpublished
                  </button>
                </div>
              )}
              <div>
                <Link
                  to={"/admin-new-course"}
                  onClick={() =>
                    localStorage.setItem(
                      "course_creation_id",
                      searchParams.get("id")
                    )
                  }
                  className={`btn btn-soft-green text-green ah-text-md fw-semibold w-auto no-shadow py-18 ${
                    isDeacrive ? "disabled-link" : ""
                  }`}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 1.99985H3.5C2.39543 1.99985 1.5 2.89528 1.5 3.99985V15.9998C1.5 17.1044 2.39543 17.9998 3.5 17.9998H15.5C16.6046 17.9998 17.5 17.1044 17.5 15.9998V9.99985M15.9142 6.41405L17 5.32829C17.781 4.54724 17.781 3.28092 17 2.49988C16.2189 1.71883 14.9526 1.71883 14.1715 2.49989L13.0858 3.58563M15.9142 6.41405L9.87795 12.4504C9.59875 12.7296 9.24315 12.9199 8.85596 12.9974L5.91422 13.5857L6.50257 10.644C6.58001 10.2568 6.77032 9.90119 7.04951 9.62199L13.0858 3.58563M15.9142 6.41405L13.0858 3.58563"
                      stroke="#82BD00"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit Course
                </Link>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-10 my-sm-20 my-md-30 my-lg-42" />
        <div className="card-default-style">
          <h2 className="ad-heading-05 fw-bold mb-10 mb-sm-20 mb-md-32">
            Source
          </h2>
          <div className="course-chapters">
            <CourseDetailChapterList chapters={getCourseDocument} />
          </div>
        </div>
        <hr className="my-10 my-sm-20 my-md-30 my-lg-42" />
        <div>
          <h2 className="ad-heading-05 fw-bold mb-10">Students</h2>
          <CourseDetailStudentTable
            totalAssignment={getCourseDetail?.totalAssignments}
            getCourseDetail={getCourseDetail?.enrolledStudents}
          />
        </div>
      </div>

      <Modal
        show={showUnpublishModal}
        onHide={() => setShowUnpublishModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Unpublish Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label htmlFor="unpublishReason" className="form-label fw-semibold">
              Reason for Unpublishing
            </label>
            <textarea
              id="unpublishReason"
              className="form-control"
              rows={4}
              value={unpublishReason}
              onChange={(e) => setUnpublishReason(e.target.value)}
              placeholder="Enter reason"
            />
            {unpublishReasonError && (
              <div className="text-danger mt-1">{unpublishReasonError}</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowUnpublishModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUnpublishSubmit}
            disabled={unpublishLoader}
          >
            {unpublishLoader ? <DottedLoading /> : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminCourseDetails;
